import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function PhoneNumberField({ settings, handleChange }) {
  const {t}=useTranslation();
  return (
    <TextField
      name="whatsapp"
      label={t("Mobile Number")}
      variant="outlined"
      value={settings?.whatsapp ?? ''}
      onChange={handleChange}
      fullWidth
      size="small"
      inputProps={{
        pattern: "[+][0-9]{1,4}[ ][0-9]{10,15}", // Simple regex for international format
      }}
    />
  );
}
